export const SIGN_IN_URL = "/admin/auth/signIn";
export const SIGN_OUT_URL = "/admin/auth/signOut";
export const REFRESH = "/admin/auth/refresh";
